import React from 'react';


export default function googlejobSchema({
    job,
    job_type,
    job_currency,
    job_payment_type,
    job_country,
    site_name,
    site_domain_link,
    site_google_logo_link,
    site_domain_jobs_link
}) {
    const schemaData = {
        "@context": "https://schema.org/",
        "@type": "WebPage",
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "name": "SRG",
                    "position": 1,
                    "item": {
                        "@type": "Thing",
                        "@id": `${site_domain_link}`
                    }
                },
                {
                    "@type": "ListItem",
                    "name": "Find a Job",
                    "position": 2,
                    "item": {
                        "@type": "Thing",
                        "@id": `${site_domain_jobs_link}`
                    }
                }
                // Add more items as needed
            ]
        },
        "mainEntity": {
            "@type": "JobPosting",
            "title": `${job?.title}`,
            "salaryCurrency": `${job_currency}`,
            "employmentType": `${job_type}`,
            "industry": ``,
            "datePosted": `${job.created_at}`,
            "description": `${job?.description}`,
            "validThrough": `${job.expires_at}`,
            "jobLocation": {
                "@type": "Place",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": `${job?.location}`,
                    "addressLocality": `${job?.location}`,
                    "addressRegion": `${job?.location}`,
                    "postalCode": "",
                    "addressCountry": `${job_country}`,
                }
            },
            "hiringOrganization": {
                "@type": "Organization",
                "name": `${site_name}`,
                "sameAs": `${site_domain_link}`,
                "logo": `${site_google_logo_link}`
            },
            "baseSalary": {
                "@type": "MonetaryAmount",
                "currency": `${job_currency}`,
                value: {
                    '@type': 'QuantitativeValue',
                    "value": `${job.salary_package}`,
                    "unitText": `${job_payment_type}`
                }
            },
            "identifier": {
                "@type": "PropertyValue",
                "name": `${site_name}`,
                "value": `${job.external_reference}`
            }
            // ...additionalScript
        }
    };
    // Additional script for QuantitativeValue
    const additionalScript = {
        "@context": "https://schema.org",
        "@type": "QuantitativeValue",
        "unitText": `${job_payment_type}`
    };
    // const schemaData = {
    //     "@context": "https://schema.org/",
    //     "@type": "JobPosting",
    //     "title": `${job?.title}`,
    //     "salaryCurrency": `${job_currency}`,
    //     "employmentType": `${job_type}`,
    //     "industry": ``,
    //     "datePosted": `${job.created_at}`,
    //     "description": `${job?.description.replace(/<[^>]*>/g, '')}`,
    //     "validThrough": `${job.expires_at}`,
    //     "jobLocation": {
    //         "@type": "Place",
    //         "address": {
    //             "@type": "PostalAddress",
    //             "streetAddress": `${job?.location}`,
    //             "addressLocality": `${job?.location}`,
    //             "addressRegion": `${job?.location}`,
    //             "postalCode": "",
    //             "addressCountry": `${job_country}`,
    //         }
    //     },
    //     "hiringOrganization": {
    //         "@type": "Organization",
    //         "name": `${site_name}`,
    //         "sameAs": `${site_domain_link}`,
    //         "logo": `${site_google_logo_link}`
    //     },
    //     "baseSalary": {
    //         "@type": "MonetaryAmount",
    //         "currency": `${job_currency}`,
    //         value: {
    //             '@type': 'QuantitativeValue',
    //             "value": `${job.salary_package}`,
    //             "unitText": `${job_payment_type}`
    //         }
    //     },
    //     "identifier": {
    //         "@type": "PropertyValue",
    //         "name": `${site_name}`,
    //         "value": `${job.external_reference}`
    //     },
    //     // BreadcrumbList
    //     "breadcrumb": {
    //         "@type": "BreadcrumbList",
    //         "itemListElement": [
    //             {
    //                 "@type": "ListItem",
    //                 "name": "SRG",
    //                 "position": 1,
    //                 "item": {
    //                     "@type": "Thing",
    //                     "@id": "https://www.srgtalent.com/"
    //                 }
    //             },
    //             {
    //                 "@type": "ListItem",
    //                 "name": "Find a Job",
    //                 "position": 2,
    //                 "item": {
    //                     "@type": "Thing",
    //                     "@id": "https://www.srgtalent.com/jobs"
    //                 }
    //             }
    //             // Add more items as needed
    //         ]
    //     }
    // }
    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(additionalScript) }}
            />
        </>
    )
}
